package com.spground.spaceplaygroundwallpaper

import org.w3c.dom.HTMLImageElement

/** Sprite loader: web replacement for BitmapFactory.decodeResource(R.drawable.*). */
object Assets {

    val ALL: List<String> = buildList {
        addAll(listOf("rocket1", "rocket2", "rocket3", "rocket4"))
        addAll(listOf("planet1", "planet2", "planet3"))
        addAll(listOf("clouds1", "clouds2", "clouds3"))
        for (i in 1..6) add("nave_a_0$i")
        for (i in 1..5) add("nave_b_0$i")
        for (i in 1..5) add("nave_c_0$i")
        for (i in 1..6) add("nave_d_0$i")
    }

    private val bitmaps = HashMap<String, Bitmap>()

    fun bitmap(name: String): Bitmap =
        bitmaps[name] ?: error("Asset not loaded: $name")

    fun load(onDone: () -> Unit) {
        var pending = ALL.size
        for (name in ALL) {
            val img = js("new Image()") as HTMLImageElement
            img.onload = {
                bitmaps[name] = Bitmap.fromImage(img, img.naturalWidth, img.naturalHeight)
                if (--pending == 0) onDone()
            }
            img.onerror = { _, _, _, _, _ ->
                console.error("Failed to load sprite: $name")
                if (--pending == 0) onDone()
            }
            img.src = "img/$name.png"
        }
    }
}
